<template>
  <div>
    <v-list-item dense class="pr-3" :class="item.IsActive ? '' : 'deactivated'" @click="$emit('click')">
      <v-list-item-icon class="mr-3 my-auto">
        <v-icon size="20">$job_categories</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        {{ item.Name }}
      </v-list-item-content>
      <v-list-item-action v-if="numberOfArticles" class="ma-0">
        <v-btn icon @click.stop="open = !open">
          <v-icon v-text="open ? 'mdi-chevron-up' : 'mdi-chevron-down'" />
        </v-btn>
      </v-list-item-action>
      <v-list-item-action class="ma-0">
        <v-switch v-model="item.IsActive" :loading="item.loading" :readonly="item.loading" @click.stop=""
          @change="e => toggleActive(e)" dense class="mt-0 px-3" hide-details>
        </v-switch>
      </v-list-item-action>
    </v-list-item>
    <template v-if="numberOfArticles && open">
      <v-divider></v-divider>
      <v-list dense style="background-color: transparent;">
        <v-list-item v-for="article in item.JobCategoryArticles" :key="article.Id"
          style="background-color: transparent; min-height: 32px;" dense>
          <v-list-item-icon class="mr-3 my-auto" style="height: unset;">
            {{ article.ArticleCount }} x
          </v-list-item-icon>
          <v-list-item-content class="py-0">
            <v-list-item-title>
              <router-link class="primary--text minimalLink pr-2" style="font-size: 13px;"
                :to="{ name: 'ViewArticle', params: { articleNumber: article.ArticleId } }">
                {{ article.ArticleId }}
              </router-link>
              {{ article.ArticleDescription }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
  </div>
</template>


<script>
import Vue from 'vue';
import clientAPI from "@/api/ClientAPIMixin.js";

export default {
  name: 'JobCategoryListItem',
  props: {
    item: Object,
  },
  components: {},

  data() {
    return {
      open: false,
    };
  },

  methods: {
    async toggleActive(boolVal) {
      Vue.set(this.item, 'loading', true);
      await clientAPI.methods.toggleJobCategoryActiveById(this.item.Id)
        .then(response => {
          this.$emit('change', response)
        })
        .catch(e => {
          console.error(e);
          this.item.IsActive = !boolVal;

        })
        .finally(() => {
          Vue.set(this.item, 'loading', false);
        });
    },
  },

  computed: {
    numberOfArticles() {
      return this.item.JobCategoryArticles && this.item.JobCategoryArticles.length;
    },
  },

  watch: {},
};
</script>


<style lang='scss'>
.deactivated {
  background-color: var(--v-disabled-lighten1) !important;
}

.deactivated:not(:hover) div {
  color: var(--v-disabled-darken2) !important;
  text-decoration: line-through !important;
}
</style>